// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./local_static/templates/especiais/verao_espetacular/assets/styles/main.scss
// module id = 332
// module chunks = 0